import axios from "axios";
import store from "@/vuex/store";

export const ApiClient = axios.create({
  baseURL:
    process.env.NODE_ENV !== "production"
      ? "https://localhost:44368/api/"
      : "https://exxonelearning.azurewebsites.net/api/",
  //: "https://exxonmobilelearning.azurewebsites.net/api/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache"
  },
  maxContentLength: Infinity
});
// following outline from https://gist.github.com/bragma/f68391596de71e1bfae066be80c259dc

ApiClient.interceptors.request.use(request => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    request.headers["Authorization"] = `Bearer ${user.accessToken}`;
  }
  return request;
});

ApiClient.interceptors.response.use(undefined, async function(error) {
  const response = error.response;

  if (response) {
    if (response.status === 401 && error.config && !error.config._retry) {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        await store.dispatch("refreshToken", {
          token: user.accessToken,
          refreshToken: user.refreshToken
        });
      } catch (authError) {
        return Promise.reject(error);
      }
      error.config._retry = true;
      return ApiClient.request(error.config);
    }
  }
  return Promise.reject(error);
});

//// Axios interceptor which allows us to display errors in snackbar
// ApiClient.interceptors.response.use(
//   function(response) {
//     // Pass through nothing to see here (2xx resopnse)
//     return response;
//   },
//   function(error) {
//     // Error handlings

//     if (error.response.data.StatusCode && error.response.data.Message) {
//       store.dispatch(
//         "snackError",
//         `${error.response.data.StatusCode} ${error.response.data.Message}`
//       );
//     } else if (error.response.data) {
//       store.dispatch("snackError", `${error.response.data}`);
//     } else {
//       store.dispatch("snackError", error.message);
//     }

//     return Promise.reject(error);
//   }
// );

export default {
  getBaseUrl() {
    return ApiClient.defaults.baseURL;
  }
};
